import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { AppConstants } from '../../app.constants';
import { PlaylistItemDTO } from '../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { PlaylistItemType } from '../../core/models/enums/playlist-item-type.enum';
import { DurationPickerComponent } from '../../misc/duration-picker/duration-picker.component';

@Component({
  selector: 'playlist-item-advanced-options',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    FormsModule,
    DurationPickerComponent
  ],
  templateUrl: './playlist-item-advanced-options.component.html',
  styleUrls: ['./playlist-item-advanced-options.component.scss']
})
export class PlaylistItemAdvancedOptionsComponent implements OnInit {
  @Input() item: PlaylistItemDTO;
  playlistItemTypes = PlaylistItemType;
  fileType: string;
  appConst = AppConstants;

  ngOnInit(): void {
    this.fileType = this.item.PlaylistFileName?.split('.').pop();

    if (this.fileType === AppConstants.PDF_FILE_TYPE) {
      this.ensureValidPdfStartPage();
    }
  }

  public onPdfDelayInputChanged(item: PlaylistItemDTO, event: Event): void {
    const value: number = +(event.target as HTMLInputElement).value;
    (event.target as HTMLInputElement).value =
      (value < AppConstants.ZERO_PDF_DELAY_INTERVAL
        ? AppConstants.MIN_PDF_DELAY_INTERVAL
        : value > AppConstants.MAX_PDF_DELAY_INTERVAL
          ? AppConstants.MAX_PDF_DELAY_INTERVAL
          : value
      ).toString();

    item.SecondsToScrollPdfPage = +(event.target as HTMLInputElement).value;
  }

  public onPdfStartPageInputChanged(item: PlaylistItemDTO, event: Event): void {
    const value: number = +(event.target as HTMLInputElement).value;
    (event.target as HTMLInputElement).value =
      (value < AppConstants.MIN_PDF_START_PAGE
        ? AppConstants.ZERO_NUMBER
        : value).toString();

    item.PlaylistItemLinks[0].PdfStartPage = +(event.target as HTMLInputElement).value;
  }

  public ensureValidPdfStartPage() {
    this.item.PlaylistItemLinks[0].PdfStartPage = this.item.PlaylistItemLinks[0].PdfStartPage || AppConstants.MIN_PDF_START_PAGE;
  }
}
